import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { confirmUserAccount } from '../../services/user/api'; // adjust path if needed

const ConfirmAccount = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
          //console.log("navigate")
  useEffect(() => {
    //console.log("useeffect")

    if (token) {
          //console.log("token")
      confirmUserAccount(token)
        .then((response) => {
          //console.log('Confirmation response:', response.data);
          alert(response.data.message || 'Account confirmed successfully!');
          navigate('/');
        })
        // .catch((error) => {
        //   console.error('Confirmation error:', error.response?.data || error.message);
        //   alert(token);
        //   //navigate('/');
        // });
    } else {
      alert('No token found in URL');
     // navigate('/');
    }
  }, [token, navigate]);

  return <div>Confirming your account...</div>;
};

export default ConfirmAccount;
